export const CONTENT_TYPE = {
  oge: 'oge',
  ege: 'ege',
};

export default { CONTENT_TYPE };
